function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#program-closed_svg__clip0_10171_472443)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.952 33.282H55.534a3.479 3.479 0 00-3.474 3.475v89.83l-.464.141-9.915 3.037a1.854 1.854 0 01-2.314-1.23L9.874 32.196a1.854 1.854 0 011.23-2.314l15.28-4.678 44.295-13.559 15.28-4.678a1.85 1.85 0 012.313 1.227l7.539 24.625.141.463z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.773 32.819L95.687 3.14A3.936 3.936 0 0090.77.528L69.288 7.103 24.995 20.664 3.513 27.242A3.941 3.941 0 00.9 32.159l31.054 101.43a3.942 3.942 0 003.766 2.786c.39 0 .779-.059 1.152-.174l14.725-4.507.464-.144v-.484l-.464.142-14.862 4.551a3.48 3.48 0 01-4.338-2.305L1.345 32.022a3.47 3.47 0 012.304-4.338l21.482-6.578L69.425 7.548 90.907.97a3.478 3.478 0 014.338 2.305l9.044 29.544.144.463h.481l-.141-.463z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.141 29.958a2.089 2.089 0 01-1.994-1.475l-2.983-9.744a2.086 2.086 0 011.383-2.603L66.297 3.66A2.087 2.087 0 0168.9 5.043l2.983 9.744a2.087 2.087 0 01-1.383 2.604L29.75 29.866c-.197.061-.402.092-.609.092z",
  fill: "#0E72ED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.769 10.765a4.632 4.632 0 100-9.264 4.632 4.632 0 000 9.264z",
  fill: "#0E72ED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.767 9.066a2.933 2.933 0 100-5.866 2.933 2.933 0 000 5.866z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.304 135.191H62.019a1.968 1.968 0 01-1.968-1.968V39.42a1.971 1.971 0 011.968-1.969h78.285a1.974 1.974 0 011.969 1.969v93.803a1.973 1.973 0 01-1.969 1.968z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.289 32.82H55.535a3.943 3.943 0 00-3.937 3.937v94.451l.463-.141v-94.31a3.478 3.478 0 013.474-3.474h48.898l-.144-.464zm42.501 0H55.535a3.943 3.943 0 00-3.937 3.937v106.078a3.94 3.94 0 003.937 3.937h91.255a3.944 3.944 0 003.937-3.937V36.757a3.94 3.94 0 00-3.937-3.938zm3.474 110.015a3.478 3.478 0 01-3.474 3.474H55.535a3.48 3.48 0 01-3.474-3.474V36.757a3.478 3.478 0 013.474-3.474h91.255a3.477 3.477 0 013.474 3.474v106.078z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.471 43.01H79.854a2.087 2.087 0 01-2.085-2.085v-10.19a2.087 2.087 0 012.085-2.085h42.617a2.088 2.088 0 012.084 2.084v10.191a2.087 2.087 0 01-2.084 2.085z",
  fill: "#0E72ED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.162 29.345a4.632 4.632 0 100-9.264 4.632 4.632 0 000 9.264z",
  fill: "#0E72ED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.161 27.534a2.821 2.821 0 10.001-5.643 2.821 2.821 0 00-.001 5.643z",
  fill: "#fff"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "program-closed_svg__clip0_10171_472443"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.727 .353)",
  d: "M0 0h150v146.419H0z"
})));
function SvgProgramClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 151 147",
    fill: "none"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "fonts/program-closed-5e3236a6218335e3d146da48bdbf4d2d.svg";
export { SvgProgramClosed as ReactComponent };